module.exports = __webpack_public_path__ + "img/edit-pen.482b97a2.svg";